import { useEffect, useRef, useState } from "react";

import {
  ACCEPT_ATTRIBUTE,
  uploadErrorMessage,
  uploadImage,
} from "../../profile/uploads";

const initials = (name) =>
  String(name || "")
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() || "")
    .join("") || "?";

const AvatarPicker = ({ name, imageUrl, onUploaded, disabled }) => {
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const input = useRef(null);

  useEffect(() => {
    if (!file) return undefined;

    const url = URL.createObjectURL(file);
    setPreview(url);

    return () => URL.revokeObjectURL(url);
  }, [file]);

  const pick = async (picked) => {
    if (!picked) return;

    setFile(picked);
    setError("");
    setBusy(true);

    try {
      onUploaded(await uploadImage(picked));
    } catch (caught) {
      setFile(null);
      setPreview(null);
      setError(uploadErrorMessage(caught));
    } finally {
      setBusy(false);
    }
  };

  const shown = preview || imageUrl;

  return (
    <div className="acct-avatar">
      <div className="acct-avatar-frame">
        {shown ? (
          <img src={shown} alt={name || "Profile"} />
        ) : (
          <span aria-hidden="true">{initials(name)}</span>
        )}

        {busy && <span className="acct-avatar-busy" aria-hidden="true" />}
      </div>

      <div className="acct-avatar-body">
        <p className="acct-avatar-name">{name || "Your profile"}</p>

        <input
          ref={input}
          type="file"
          accept={ACCEPT_ATTRIBUTE}
          hidden
          onChange={(event) => pick(event.target.files?.[0])}
        />

        <button
          type="button"
          className="sy-flow-link"
          disabled={busy || disabled}
          onClick={() => input.current?.click()}
        >
          {busy ? "Uploading…" : shown ? "Change photo" : "Add a photo"}
        </button>

        {error && <p className="acct-field-note">{error}</p>}
      </div>
    </div>
  );
};

export default AvatarPicker;
